export const PAYMENT_METHODS = {
  STRIPE: "STRIPE",
  ONE_PAY: "ONE_PAY",
  VNPAY: "VNPAY",
  IMP_EXIMBAY: "IMP~EXIMBAY",
  IMP_PAYPAL: "IMP~PAYPAL",
  EXIMBAY: "EXIMBAY",
  PAYPAL: "PAYPAL",
  PORT_ONE: "PORT_ONE",
  PAYMENTWALL: "PAYMENTWALL",
  FREE: "FREE",
};
